import { Injectable } from '@angular/core';
import { HttpService } from '../http.service';
import { ServerInfoService } from '../server-info.service';
import { OrderMapperService } from './order-mapper.service';
import { OrderState } from '../../_models/order-state';
import { OrderStateV2 } from '../../_models/v2/order-state-v2';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OrderServiceV2 {
  // Base URL for the V2 API
  private apiBaseUrl = `${environment.dataUrl}/v2`;

  constructor(
    private httpService: HttpService,
    private serverInfoService: ServerInfoService,
    private orderMapperService: OrderMapperService
  ) { }

  /**
   * Gets active orders from the V2 API endpoint and maps them to the original model format
   * @param customerNo Optional customer number
   * @returns A list of orders in the original model format
   */
  public async getOrders(customerNo?: string | null): Promise<Array<OrderState>> {
      // Call the V2 API endpoint
      const ordersV2 = await this.httpService.getDataWithOfflineCheck<Array<OrderStateV2>>(
        `${this.apiBaseUrl}/orders/active/${customerNo || ""}`
      );

      // Convert plain objects to typed V2 instances
      const typedOrdersV2 = this.orderMapperService.plainToOrderStateV2List(ordersV2);
      
      // Map V2 models to original format
      var mapped = this.orderMapperService.mapToOriginalList(typedOrdersV2);
      return mapped;
  }
} 